export default __webpack_public_path__ + "static/media/provider_15.cf595d9b.png";